export enum PAGES {
  ROOT = "/",
  SETTINGS = "/settings",
  AUTH = "/auth/login",
  CONFIRM_LOGIN = "/auth/confirmation",
  SEND = "/send",
  RECEIPT = "/receipt",
  DOCUMENTS = "/documents",
  STATISTICS = "/statistics",
  DASHBOARD = "/dashboard",
  TRACKING = "/tracking/:orderId",
  CREATE_DISPATCH='/create-dispatch',
  ERROR_404 = "*",
}

export type ParsedSearchParams = Record<string, string>;

export type Scheme<Endpoints extends PAGES = PAGES> = {
  scheme: Endpoints;
  params?: Record<string, string>;
  getParams?: ParsedSearchParams;
};

export type ParsedPathname = string[];

export type Path = {
  pathname: string;
  search?: string;
};

export type FeScheme = Scheme<PAGES> | [Scheme<PAGES>];
